import { render, staticRenderFns } from "./VideoTimeline.vue?vue&type=template&id=8165f8bc"
import script from "./VideoTimeline.vue?vue&type=script&lang=js"
export * from "./VideoTimeline.vue?vue&type=script&lang=js"
import style0 from "./VideoTimeline.vue?vue&type=style&index=0&id=8165f8bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports